import client from "../../../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../../../client";
import type {
  PostApiLoginAuthorizeMutationRequest,
  PostApiLoginAuthorizeMutationResponse,
} from "../../../types/PostApiLoginAuthorize";

export function getPostApiLoginAuthorizeUrl() {
  return `/api/Login/Authorize` as const;
}

/**
 * {@link /api/Login/Authorize}
 */
export async function postApiLoginAuthorize(
  data?: PostApiLoginAuthorizeMutationRequest,
  config: Partial<RequestConfig<PostApiLoginAuthorizeMutationRequest>> & {
    client?: typeof client;
  } = {}
) {
  const { client: request = client, ...requestConfig } = config;

  const res = await request<
    PostApiLoginAuthorizeMutationResponse,
    ResponseErrorConfig<Error>,
    PostApiLoginAuthorizeMutationRequest
  >({
    method: "POST",
    url: getPostApiLoginAuthorizeUrl().toString(),
    data,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res;
}
